import { render, staticRenderFns } from "./Tier.vue?vue&type=template&id=633e04d0&scoped=true"
import script from "./Tier.vue?vue&type=script&lang=js"
export * from "./Tier.vue?vue&type=script&lang=js"
import style0 from "./Tier.vue?vue&type=style&index=0&id=633e04d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e04d0",
  null
  
)

export default component.exports